import {createContext} from 'react'

export const mfoFilterContext=createContext({});